/* eslint-disable react/destructuring-assignment */
import React from "react";

const PlayConsentIcon = props => {
  const { ...restProps } = props;

  return (
    <svg
      width="11"
      height="14"
      viewBox="0 0 11 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "6px",
        verticalAlign: "middle",
      }}
      {...restProps}
    >
      <path d="M10.525 6.15594L1.52 0.647187C1.36818 0.55422 1.19429 0.503468 1.0163 0.500171C0.838305 0.496875 0.662659 0.541155 0.5075 0.628437C0.353819 0.714363 0.225798 0.839674 0.136602 0.991481C0.0474072 1.14329 0.000256786 1.31612 0 1.49219V12.5084C0.00115798 12.7726 0.107146 13.0254 0.294665 13.2114C0.482184 13.3974 0.735885 13.5013 1 13.5003C1.18435 13.5002 1.36511 13.4494 1.5225 13.3534L10.525 7.84469C10.6697 7.75649 10.7893 7.63255 10.8723 7.48479C10.9553 7.33703 10.9989 7.17041 10.9989 7.00094C10.9989 6.83147 10.9553 6.66485 10.8723 6.51709C10.7893 6.36932 10.6697 6.24539 10.525 6.15719V6.15594ZM1 12.4966V1.50031L9.98938 7.00031L1 12.4966Z" />
    </svg>
  );
};

export default PlayConsentIcon;
